import React, { useEffect, useMemo, useRef, useState } from "react";
import boardImage from "../../../assets/game/board-restaurent.png";
import CommonErrorPopup from "../CommonErrorPopup";
import "./TextStage.css";

export default function TextStage({ data, onDone, onSessionPointsChange }) {
  const [answer, setAnswer] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Please fill out the text box.");
  const [inputBgColor, setInputBgColor] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const wrongResultSubmittedRef = useRef(false);

  const normalize = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/^["']+|["']+$/g, "")
      .replace(/,\s*$/, "")
      .replace(/\s+/g, " ")
      .trim();

  const normalized = useMemo(() => normalize(answer), [answer]);
  const val1 = useMemo(() => normalize(data.answerVariants?.[0]), [data.answerVariants]);
  const val2 = useMemo(() => normalize(data.answerVariants?.[1]), [data.answerVariants]);
  const displayCorrectAnswer = useMemo(() => {
    const preferred = data.answerVariants?.find((v) => String(v || "").trim());
    const resolved = preferred ?? data.answer ?? "";
    return String(resolved).trim();
  }, [data.answerVariants, data.answer]);

  const handleLiveValidation = (rawValue) => {
    if (readOnly || isCompleted) return;
    const live = normalize(rawValue);

    if (!live) {
      setInputBgColor("");
      setSubmitDisabled(true);
      return;
    }

    if (live === val1 || live === val2) {
      setInputBgColor("green");
      setReadOnly(true);
      setSubmitDisabled(false);
      setIsCompleted(true);
      onSessionPointsChange?.(5);
      onDone(5);
      return;
    }

    setInputBgColor("red");
    setSubmitDisabled(false);
  };

  const submit = () => {
    if (readOnly || isCompleted) return;

    if (!normalized) {
      setInputBgColor("");
      setSubmitDisabled(true);
      setErrorMessage("Please fill out the text box.");
      setErrorOpen(true);
      return;
    }

    if (normalized === val1 || normalized === val2) {
      setInputBgColor("green");
      setReadOnly(true);
      setSubmitDisabled(false);
      onSessionPointsChange?.(5);
      onDone(5);
      return;
    }

    setInputBgColor("red");
    setSubmitDisabled(false);
    setErrorMessage(displayCorrectAnswer ? `Wrong answer.\nCorrect Answer: ${displayCorrectAnswer}` : "Wrong answer");
    wrongResultSubmittedRef.current = false;
    setErrorOpen(true);
  };

  const handleErrorPopupOk = () => {
    setErrorOpen(false);
    if (wrongResultSubmittedRef.current) return;
    wrongResultSubmittedRef.current = true;
    onDone(0);
  };

  return (
    <>
      <div className="unhealthy-stage text-stage rest-text-stage">
        <div className="text-stage__content">
        <h1>WEAKER HAS MADE IT HARDER FOR YOU TO ACCESS HEALTHY FOOD ON THE MENU</h1>
          <p>In the below cryptogram, each letter has been replaced by another letter or symbol.</p>
          <p>Solve the puzzle to figure out which letters correspond to which symbols in order to decode the message.</p>
        </div>
        <div className="text-stage__board-wrap">
          <img src={boardImage} alt="Cryptogram board" className="text-stage__board-image" />
          {/* <div className="text-stage__board-text">H KPLA DPAO CHYPLAF: CLNNPLZ ZOVBSKUA IL ZJHYF!</div> */}
        </div>

        <input
          value={answer}
          readOnly={readOnly}
          onChange={(e) => {
            const nextValue = e.target.value;
            setAnswer(nextValue);
            handleLiveValidation(nextValue);
          }}
          onKeyUp={(e) => handleLiveValidation(e.currentTarget.value)}
          placeholder="Enter answer"
          className="text-stage-input text-stage__input"
          style={{ backgroundColor: inputBgColor }}
        />

        <button type="button" className="stage-submit text-stage__submit" onClick={submit} disabled={submitDisabled}>
          Submit
        </button>
      </div>
      <CommonErrorPopup
        open={errorOpen}
        message={errorMessage}
        onClose={handleErrorPopupOk}
      />
    </>
  );
}
